import React from 'react';
import Styled from 'styled';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { Query } from '@apollo/client/react/components';

import LoadingProgress from 'lib/react-router/loading-progress';
import SVGIcon from 'lib/images/svg-icon/svg-icon';

import rightArrowIcon from 'four-nets/icons/svg/icon_arrow-right.svg';
import ErrorPage from 'four-nets/errors/error-page';
import query, {
    RecommendedCollectionQuery,
    RecommendedCollectionQueryVariables,
} from 'four-nets/photoblog/collections/collection/recommended-collections/recommended-collections-loader.graphql';
import CollectionNode from 'four-nets/photoblog/collections/collections/collection-node/collection-node';

import defaultStyles from './recommended-collections.scss';

export interface Props {
    styles: typeof defaultStyles;
}

class RecommendedCollections extends React.PureComponent<Props> {
    render() {
        const { styles } = this.props;

        return (
            <Query<RecommendedCollectionQuery, RecommendedCollectionQueryVariables>
                query={query}
                variables={{
                    first: 2,
                    modifiedAfterNDays: 31,
                }}
                fetchPolicy='cache-first'
            >
                {({ loading, error, data }) => (
                    <LoadingProgress loading={loading}>
                        <ErrorPage error={error}>
                            {data && data.collections && data.collections.edges && data.collections.edges.length ? (
                                <div className={styles.container}>
                                    <FormattedMessage id='RECOMMENDED_COLLECTIONS'>
                                        {msg => <p className={styles.header}>{msg}</p>}
                                    </FormattedMessage>
                                    <ul className={styles.recommendedCollections}>
                                        {data.collections.edges.map(edge => {
                                            if (!edge || !edge.node) {
                                                return null;
                                            }
                                            return (
                                                <li className={styles.recommendedCollection} key={edge.node.id}>
                                                    <CollectionNode
                                                        style={{
                                                            header: styles.header,
                                                            headerInfo: styles.headerInfo,
                                                            username: styles.username,
                                                            images: styles.images,
                                                            footer: styles.footer,
                                                            title: styles.title,
                                                            iconCamera: styles.iconCamera,
                                                            statText: styles.statText,
                                                        }}
                                                        {...edge.node}
                                                    />
                                                </li>
                                            );
                                        })}
                                    </ul>
                                    <Link to='/blogs/collections/' className={styles.link}>
                                        <FormattedMessage id='SHOW_EVERYTHING'>
                                            {msg => <span className={styles.linkText}>{msg}</span>}
                                        </FormattedMessage>
                                        <SVGIcon className={styles.linkImage} src={rightArrowIcon} />
                                    </Link>
                                </div>
                            ) : null}
                        </ErrorPage>
                    </LoadingProgress>
                )}
            </Query>
        );
    }
}

export default Styled(defaultStyles)(RecommendedCollections);
